export enum SaveEventAction {
    add,
    edit,
    delete,
}